import { render, staticRenderFns } from "./ProcessImport.vue?vue&type=template&id=f9f22f56"
import script from "./ProcessImport.vue?vue&type=script&lang=js"
export * from "./ProcessImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports